import { DEFAULT_MARKETPLACE } from '../../helpers/constants';

const initialState = {
  activeMarketplace: DEFAULT_MARKETPLACE,
  marketplaceComps: [],
  showMPListPrice: false,
  showTMRListPrice: false,
  showSHListPrice: false,
  showVSListPrice: false,
};

function globals(state = initialState, action) {
  switch (action.type) {
    case 'SET_ACTIVE_MARKETPLACE':
      return {
        ...state,
        activeMarketplace: action.marketplace,
      };
    case 'SET_MARKETPLACE_COMPS':
      return {
        ...state,
        marketplaceComps: action.comps,
      };
    case 'SET_SHOW_TMR_LIST_PRICE':
      return {
        ...state,
        showTMRListPrice: action.status,
      };
    case 'SET_SHOW_SH_LIST_PRICE':
      return {
        ...state,
        showSHListPrice: action.status,
      };
    case 'SET_SHOW_VS_LIST_PRICE':
      return {
        ...state,
        showVSListPrice: action.status,
      };
    case 'SET_SHOW_MP_LIST_PRICE':
      return {
        ...state,
        showMPListPrice: action.status,
      };
    default:
      return state;
  }
}

export default globals;
